import { useSelector } from 'react-redux';

export default () => {
  const { userDetails } = useSelector(state => state.auth);
  if (!userDetails) return {};
  const { userId, firstName, lastName, username } = userDetails;

  return { userId, userFirstName: firstName, userLastName: lastName, username };
};
